import { ProductionReportProvider } from 'contexts/kitchen/production-report.context';
import React from 'react';
import ProductionReportContent from './content';

const ProductionReportLayout = () => {
  return (
    <ProductionReportProvider>
      <ProductionReportContent />
    </ProductionReportProvider>
  );
};

export default ProductionReportLayout;
